import { render } from "./PrismicImageBlock.vue?vue&type=template&id=c1e280de"
import script from "./PrismicImageBlock.vue?vue&type=script&lang=js"
export * from "./PrismicImageBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__